import styled from "styled-components";

export const InputFieldsWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 24px;

  > div:nth-child(1) {
    padding-right: 8px;
  }

  > div:nth-child(2) {
    padding-left: 8px;
  }

  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    flex-direction: column;
    > div:nth-child(1) {
      margin-bottom: 24px;
      padding-right: 0;
    }

    > div:nth-child(2) {
      padding-left: 0;
    }
  }
`
